export * from './delete-vorlage.component';
export * from './delete-vorlage.component.module';